/* -------------------------------------------------------------------------- */
/*                                Tab styles                               */
/* -------------------------------------------------------------------------- */

:host {
  @apply block;
}

.bq-tab-group {
  @apply relative;

  &::after {
    @apply absolute flex border-0 border-solid border-primary content-empty;
  }

  &--horizontal-start,
  &--horizontal-end {
    &::after {
      @apply is-full inset-be-0 [border-block-end-width:--bq-stroke-s];
    }
  }

  &--horizontal-start {
    @apply justify-start;
  }

  &--horizontal-end {
    @apply justify-end;
  }

  &--vertical-start::after {
    @apply end-0 bs-full is-0 [border-block-end-width:0px] [border-inline-end-width:--bq-stroke-s];
  }

  &--vertical-end::after {
    @apply start-0 bs-full is-0 [border-block-end-width:0px] [border-inline-start-width:--bq-stroke-s];
  }
}

.bq-tab-group.no-divider {
  &::after {
    @apply content-none;
  }
}

.bq-tab-group--container {
  @include hide-scrollbar;
  @apply gap-xs2 p-xs2; // This will avoid cutting the outline focus style
}
